import { combineStrings } from 'assets/utils/data/String';
import InputType from 'models/enums/InputType';
import Model from 'models/Model';

export default class ProductTransferOwnershipFillablePdfField
  extends Model<Model.IProductTransferOwnershipFillablePdfField>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IProductTransferOwnershipFillablePdfField>
{
  id: number;
  key: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  group?: string;
  label?: string;
  type?: InputType;
  propertyPath?: string;
  defaultValue?: string | number | boolean;

  productTransferOwnershipDocumentId: number;

  constructor(
    data:
      | Partial<Model.IProductTransferOwnershipFillablePdfField>
      | Utils.FormData<Model.IProductTransferOwnershipFillablePdfField>,
    language?: Locale.Languages
  ) {
    super({}, language);
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: combineStrings(' | ', this.label, this.key),
      info: this.group,
      subtitle: this.type,
    };
  }
}
